<script>
    import { Row, Col } from 'sveltestrap'
    import FormSavingButtons from '../FormSavingButtons.svelte'
    import { InputCheckbox } from '@fno/component2/form.js'
    import FormAlerts from '../FormAlerts.svelte'

    export let context
    export let saving
</script>

<h1>Apple Developer Account</h1>

<p>Please watch the short instructional video below about setting up your Developer Accounts.</p>

<Row>
    <Col class="text-center">
        <iframe
            title="embedded video about app naming"
            width="560"
            height="315"
            src="https://www.youtube.com/embed/8hf78OIkXL0?&wmode=opaque"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
        />
    </Col>
</Row>

<Row class="my-5">
    <Col>
        <ol>
            <li>
                Lookup your school's D-U-N-S number by clicking
                <a href="https://developer.apple.com/support/D-U-N-S/" target="_blank">here</a>
                and then clicking “D-U-N-S Number lookup tool”
            </li>
            <li>
                Visit the
                <a href="https://developer.apple.com/programs/enroll/" target="_blank">enrollment</a>
                website where you will begin the process of enrolling
            </li>
            <li>You will receive a confirmation email within 5 business days confirming the setup of your account.</li>
            <li>
                Add FNO (Sue Thaden - info@fanxstudentx.com) as an ADMIN on your developer account -
                <a href="https://itunesconnect.apple.com/login" target="_blank">Login Here</a>
            </li>
        </ol>
    </Col>
</Row>

<Row>
    <Col>
        <InputCheckbox
            required
            {context}
            formKey="clientOnboarding"
            keypath="attributes.steps.DEVELOPER_ACCOUNT.understood"
            label="I have read and understand how to set up my Apple Developer Account."
            bind:value={context.form.clientOnboarding.attributes.steps.DEVELOPER_ACCOUNT.understood}
            on:change
        />
    </Col>
</Row>

<FormAlerts bind:alerts={context.alerts} />

<FormSavingButtons {context} {saving} on:save on:nextStepClicked on:previousStepClicked />
